import React from "react";
import { useStyles } from "./DecisionReview.css";
import Button from "@mui/material/Button";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import { NavLink } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
// Component for rendering content of the bottom bar during review mode
// This includes the stepper for navigating between scored scenes to replay
// them in slow motion, as well as the button for ending the review and rendering
// the splash screen for the final overview and the button for navigating to the next scene
// in the playlist

const DecisionReviewSceneNav = ({
    handleStep,
    activeStep,
    decisions,
    reviewEnd,
    sessionInfo,
    feedbackMode,
    endRun,
}) => {
    const classes = useStyles();
    const intl = useIntl();
    const getRedirectInfo = () => {
        if (sessionInfo.isReplay === false && endRun === false) {
            return {
                pathname: "/game/session",
                state: {
                    playlistName: sessionInfo.playlistName,
                    scoredSceneCount: sessionInfo.scoredSceneCount,
                    courseId: sessionInfo.courseId,
                    playlistId: sessionInfo.playlistId,
                    isReplay: sessionInfo.isReplay,
                    feedbackMode: feedbackMode,
                },
            };
        } else {
            return {
                pathname: "/game/dashboard",
            };
        }
    };

    return (
        <div className={classes.reviewSceneNavContainer}>
            <NavLink to={getRedirectInfo} style={{ textDecoration: "none" }}>
                <Button className={classes.sceneTimelineButton}>
                    <FormattedMessage
                        id={"app.game.buttons.review.next.video"}
                        defaultMessage={"Next Video"}
                    />
                </Button>
            </NavLink>

            {feedbackMode === "standard" && (
                <NavLink to={"/game/dashboard"}>
                    <Button className={classes.sceneTimelineButton}>
                        <FormattedMessage
                            id={"app.game.buttons.review.break"}
                            defaultMessage={"Take a Break"}
                        />
                    </Button>
                </NavLink>
            )}
            {feedbackMode === "standard" && (
                <Stepper
                    nonLinear
                    activeStep={activeStep}
                    className={classes.sceneTimeline}
                >
                    {decisions.map((decision, index) => (
                        <Step key={index}>
                            <StepButton
                                onClick={() => {
                                    handleStep(index, decision.time);
                                }}
                            />
                        </Step>
                    ))}
                </Stepper>
            )}
            {feedbackMode === "lab" && (
                <Stepper
                    linear
                    activeStep={activeStep}
                    className={classes.sceneTimeline}
                >
                    {decisions.map((decision, index) => (
                        <Step key={index}>
                            <StepButton />
                        </Step>
                    ))}
                </Stepper>
            )}
        </div>
    );
};

export default DecisionReviewSceneNav;
